import type { SemanticBlock } from "@/lib/calendar/semantics";

/**
 * Renders deterministic per-page unique copy + FAQ.
 * NOTE: FAQPage JSON-LD intentionally removed — Google deprecated FAQ rich
 * results, so we keep the visible Q&A but no longer emit structured data.
 * Adds entity surface for SEO without duplicating boilerplate across pages.
 */
export function SemanticSection({
  block,
  heading,
  className,
}: {
  block: SemanticBlock;
  heading: string;
  className?: string;
}) {
  return (
    <section
      data-pseo
      className={className ?? "rounded-lg border border-border bg-card p-5"}
    >
      <h2 className="mb-3 font-display text-xl">{heading}</h2>
      <div className="space-y-2 text-sm text-muted-foreground">
        {block.paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
      {block.faq.length > 0 && (
        <div className="mt-5 space-y-3">
          <h3 className="text-sm font-semibold">Pertanyaan yang sering diajukan</h3>
          <dl className="space-y-3">
            {block.faq.map((f) => (
              <div key={f.q}>
                <dt className="text-sm font-medium">{f.q}</dt>
                <dd className="text-sm text-muted-foreground">{f.a}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}
    </section>
  );
}
